const React = require('react');
const UserInfo = require('routes/signup/components/UserInfo');
const EditPage = require('routes/app/profile/components/EditPage');
const HarnessUtils = require('./userInputsHarnessUtils');

const {
    useMemo,
    useState
} = React;

const internals = {};

internals.getQueryParams = () => new URLSearchParams(window.location.search);

module.exports = function UserInputsHarnessPage() {

    const query = internals.getQueryParams();
    const page = query.get('page') === 'edit' ? 'edit' : 'signup';
    const fixture = query.get('fixture') || undefined;
    const view = query.get('view') || 'student';
    const [state, setState] = useState({
        invalidCount: 0,
        lastSubmit: null,
        lastNavigation: null
    });

    const handlers = useMemo(() => ({
        onInvalidSubmit: () => {

            setState((current) => ({
                ...current,
                invalidCount: current.invalidCount + 1
            }));
        },
        onSubmit: async (signupDetails, redirectPath) => {

            setState((current) => ({
                ...current,
                lastSubmit: {
                    mode: 'redirect',
                    redirectPath,
                    signupDetails
                }
            }));

            return {
                payload: {
                    ok: true
                }
            };
        },
        onSubmitNoRedirect: async (signupDetails) => {

            setState((current) => ({
                ...current,
                lastSubmit: {
                    mode: 'no-redirect',
                    signupDetails
                }
            }));
        }
    }), []);

    const history = useMemo(() => ({
        push: (path, locationState) => {

            setState((current) => ({
                ...current,
                lastNavigation: {
                    path,
                    locationState
                }
            }));
        }
    }), []);

    const pageProps = page === 'edit'
        ? HarnessUtils.buildEditPageProps({
            fixture,
            view,
            handlers,
            history
        })
        : HarnessUtils.buildUserInfoProps({
            fixture,
            view,
            handlers
        });

    const PageComponent = page === 'edit' ? EditPage : UserInfo;

    return <div data-testid='user-inputs-harness'>
        <div
            data-testid='user-inputs-harness-state'
            style={{
                position: 'absolute',
                left: '-10000px',
                top: 0
            }}
        >
            <div>page: {page}</div>
            <div>view: {view}</div>
            <div>fixture: {fixture || 'default'}</div>
            <div data-testid='invalid-submit-count'>invalid submits: {state.invalidCount}</div>
            <pre data-testid='last-submit-json'>{JSON.stringify(state.lastSubmit, null, 2)}</pre>
            <pre data-testid='last-navigation-json'>{JSON.stringify(state.lastNavigation, null, 2)}</pre>
        </div>
        <PageComponent {...pageProps} />
    </div>;
};
